import { createSlice } from '@reduxjs/toolkit';
import moment from "moment";

const initialState = {
    username: "",
    password: "",
    display_name: "",
    email: "",
    status: 1,
    country: [],
    city: "",
    avatar: {},
    birth_date: null,
    gender: 1,
    orientation: 0,
    website: "",
    about_me: "",
    current_avatar: "",
    current_thumbnail: "",
    current_cover: "",
    languages: [],
    education: [],
    first_name: "",
    last_name: "",
    cover: {},
    age: "",
    ethnicity: 0,
    drinking: 1,
    smoking: 1,
    hair_length: 0,
    hair_color: 0,
    eye_color: 0,
    biography: "",
    relationship: 0,
    tattoos: 0,
    piercings: 0,
    career_status: 0,
    career_start: "",
    career_end: "",
    tagsNew: []
}

export const modelSlice = createSlice({
    name: 'model',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = modelSlice.actions

export default modelSlice.reducer